import { yupResolver } from "@hookform/resolvers/yup";
import { Modal } from "antd";
import Button from "comps/Button";
import Input from "comps/Input";
import { useApiKeysEnvironmentContext } from "context/ApiKeysEnvironment";
import { useUserAuthContext } from "context/UserAuthContext";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { fetchBusiness, getApiKeys, login } from "services";
import { getUser, useUpdateUser } from "services/auths";
import { loginFormTypes } from "utils/types";
import { loginSchema } from "validations";

const APIKeysWebhooks = (props: any) => {
  const { handleChange } = props;
  const [secretType, setSecretType] = useState<"password" | "text">("password");
  const [loginModal, setLoginModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [apikeKeys, setApikeys] = useState(null);
  const [isSecretRevealed, setIsSecretRevealed] = useState(false);
  const { userDetails: { user: { userId }, user, }, setUserDetails, } = useUserAuthContext();

  const { handleUpdateUser } = useUpdateUser()

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    mode: "onTouched",
    resolver: yupResolver(loginSchema),
  });

  type ApiKeyForm = {
    redirectUrl: string;
    webhookUrl: string;
  };
  const apiForm = useForm<ApiKeyForm>({
    defaultValues: {
      redirectUrl: user?.profile?.redirectUrl || "",
      webhookUrl: user?.profile?.webhookUrl || "",
    },
    mode: "onTouched",
  });

  const fetchUserDetails = async () => {
    const res = await getUser(userId);
    if (res.status >= 200 && res.status <= 299) {
      apiForm.setValue("webhookUrl", res.data?.data?.profile?.webhookUrl);
      apiForm.setValue("redirectUrl", res.data?.data?.profile?.redirectUrl);
    } else {
    }
  };

  useEffect(() => {
    fetchUserDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const onSubmitApiKeys = async (data: ApiKeyForm) => {
    await handleUpdateUser({
      webhookUrl: data?.webhookUrl,
      redirectUrl: data?.redirectUrl,
    })
    fetchUserDetails()
  };

  const onSubmit = async (data: loginFormTypes) => {
    const { email, password } = data;
    setLoading(true);
    const res = await login({ email, password });
    setLoading(false);
    if (res.status >= 200 && res.status < 299) {
      const keys = await getApiKeys(userId);
      console.log("api - keys", keys);
      if (keys.status >= 200 && keys.status <= 299) {
        toast.success(`${keys?.data?.message || "Success"}`);
        setSecretType("text");
        setApikeys(keys?.data?.data?.secretKey);
        setIsSecretRevealed(true);
        setLoginModal(!loginModal);
      } else toast.error(`Error: No Api-keys yet! try again`);

      setUserDetails(res?.data?.data);
      localStorage.setItem("authDetails", JSON.stringify(res?.data?.data));
      return;
    } else {
    return toast.error(`Error: ${res?.data?.error}`, {
      duration: 3000,
    });
    }
  };

  const fetcBusinessDetails = async () => {
    const data = await fetchBusiness(userId);
    if (data.status >= 200 && data.status <= 299) {
      setApikeys(data?.data?.data?.docs?.[0]);
      apiForm.setValue("redirectUrl", user?.profile?.redirectUrl);
      apiForm.setValue("webhookUrl", user?.profile?.webhookUrl);
    }
  };
  useEffect(() => {
    fetcBusinessDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyPayload = (payload: string) => {
    navigator.clipboard.writeText(payload);
    toast.success(`Secret Key Copied!`);
  };

  const { apikeysEnvironment } = useApiKeysEnvironmentContext();
  if (apikeysEnvironment === "test") {
    return (
      <div className=" w-full bg-white text-center md:w-6/12 mt-10 drop-shadow-sm mx-auto border border-[#D5D7D8] rounded-lg p-4 py-10 min-h-[440px]">
        <Modal
          open={loginModal}
          title="Provide Account Details"
          onCancel={() => setLoginModal(!loginModal)}
          okText="Submit"
          okButtonProps={{ htmlType: "submit" }}
          onOk={handleSubmit(onSubmit)}
          confirmLoading={loading}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <small className="text-pink-700 font-bold">
              Provide your account details to get your secret api keys!
            </small>
            <div className="flex flex-col gap-y-5">
              <Controller
                control={control}
                name="email"
                render={({ field }) => (
                  <Input
                    {...field}
                    type="email"
                    label="Email"
                    placeholder="Enter your email"
                    extraClass="w-full"
                    error={errors?.email?.message}
                  />
                )}
              />
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    label="Password"
                    type="password"
                    placeholder="Enter your password"
                    extraClass="w-full"
                    error={errors.password?.message}
                  />
                )}
              />
            </div>
          </form>
        </Modal>
        <div className="w-11/12 mx-auto">
          <h1 className="mb-6">API Configuration</h1>
          <form
            onSubmit={apiForm.handleSubmit(onSubmitApiKeys, e=> console.log(e))}
            className="w-11/12 mx-auto text-left"
          >
            <div className="flex items-center gap-x-3">
              <Input
                label="Secret Key"
                placeholder="********************"
                extraClass="mb-4 flex-1"
                className="font-bold text-black"
                disabled
                type={secretType}
                value={apikeKeys!}
              />
              <Button
                onClick={() => isSecretRevealed ? copyPayload(apikeKeys!) : setLoginModal(!loginModal)}
                className="text-xs mt-1 p-0 w-fit h-fit"
                type="button"
              >
                {isSecretRevealed ? "Copy Secret" : "View Secret"}
              </Button>
            </div>
            <Controller
              control={apiForm.control}
              name="redirectUrl"
              render={({ field }) => (
                <Input
                  {...field}
                  name="redirectUrl"
                  label="Redirect URL"
                  placeholder="Redirect URL"
                  extraClass="mb-4"
                />
              )}
            />

            <Controller
              control={apiForm.control}
              name="webhookUrl"
              render={({ field }) => (
                <Input
                  {...field}
                  name="webhookUrl"
                  label="Webhook URL"
                  placeholder="Webhook URL"
                  extraClass="mb-4"
                />
              )}
            />

            <Button
              variant="primary"
              type="submit"
              className="w-40 mx-auto flex justify-center mt-10 drop-shadow-md"
            >
              Save Changes
            </Button>
          </form>
        </div>
      </div>
    );
  } else
    return (
      <div className="flex items-center justify-center w-full bg-white text-center md:w-6/12 mt-10 drop-shadow-sm mx-auto border border-[#D5D7D8] rounded-lg p-4 py-10 min-h-[440px]">
        <div className="bg-[#F3F5F8] p-3 h-fit">
          <p className="text-primary">
            To access the Live mode,Kindly provide the documents required by{" "}
            <button type="submit" onClick={() => handleChange("item-3")}>
              click here
            </button>
          </p>
        </div>
      </div>
    );
};

export default APIKeysWebhooks;
